module.exports = __webpack_public_path__ + "img/dashboard2.3de49aaf.jpg";